// extracted by mini-css-extract-plugin
export default {"gallery":"GalleryPreview_gallery__jFxia"};